import {
    FETCH_ME,
    EDIT_ME,
    EDIT_BUSINESS,
    SUBMIT_START_SURVEY,
    CHECK_START_SURVEY
} from '../actions/types';

const INITIAL_STATE = {
    survey: { startSurvey: false },
    dataSettings: {
        currency: { label: 'EUR', symbol: '€' },
        index: { salary: 4, consultant: 4, premises: 4, rental: 4, leasing: 4 }
    }
};

const profileReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ME:
            return { ...state, user: action.payload.user, business: action.payload.business }
        case EDIT_ME:
            return { ...state, user: action.payload.user }
        case EDIT_BUSINESS:
            return { ...state, business: action.payload.business }
        case SUBMIT_START_SURVEY:
            return { ...state, survey: { startSurvey: action.payload.start_survey } }
        case CHECK_START_SURVEY:
            return { ...state, survey: { startSurvey: action.payload.start_survey } }
        default:
            return state
    }
};

export default profileReducer;
